module.exports = __webpack_public_path__ + "static/media/chevron_white.a036ff1a.svg";